var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 292.81 319.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-3);}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 202.72,
    y1: 165.08,
    x2: 275.63,
    y2: 165.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0678c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b9fe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 221,
    x2: 292.81,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb621e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdce06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 40.7,
    y1: 54.83,
    x2: 113.61,
    y2: 54.83,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 159.76,
    x2: 292.81,
    y2: 159.76,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.19,172.39V283.52a36,36,0,0,1-72,0V180.07h43.36A57,57,0,0,0,275.19,172.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.3,109.66H231.06c-.44,0-.88,0-1.31,0a28.33,28.33,0,0,1-27-26.86c0-.48,0-1,0-1.44V47.09c0-.58,0-1.16,0-1.73A36.46,36.46,0,0,1,237.9,10.65l1.28,0h0c.52,0,1,0,1.55,0A36.47,36.47,0,0,1,275.6,45.38q0,.84,0,1.71V81.33c0,.4,0,.8,0,1.19a28.34,28.34,0,0,1-26.71,27.1C248.37,109.65,247.84,109.66,247.3,109.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.81,122.47c0,.47,0,.94,0,1.4a46.3,46.3,0,0,1-44.59,44.85c-.55,0-1.11,0-1.66,0H173a59.81,59.81,0,0,0-59.82,59.8v55a36,36,0,0,1-72,0V192.16l-8.26,9A44.69,44.69,0,0,1,0,215.57l21-46.46a79.18,79.18,0,0,1,72.2-46.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.15,109.66h-1A36.46,36.46,0,0,1,40.72,74.58c0-.46,0-.91,0-1.37V36.46c0-.44,0-.88,0-1.32A36.46,36.46,0,0,1,76.3,0h.85c.49,0,1,0,1.45,0a36.45,36.45,0,0,1,35,34.95c0,.49,0,1,0,1.48V73.21c0,.4,0,.8,0,1.19a36.46,36.46,0,0,1-35.35,35.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.81,122.47c0,.47,0,.94,0,1.4a46.3,46.3,0,0,1-44.59,44.85c-.55,0-1.11,0-1.66,0H173a59.81,59.81,0,0,0-59.82,59.8v55a36,36,0,0,1-72,0V192.16l-8.26,9A44.69,44.69,0,0,1,0,215.57l21-46.46a79.18,79.18,0,0,1,72.2-46.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.15,109.66h-1A36.46,36.46,0,0,1,40.72,74.58c0-.46,0-.91,0-1.37V36.46c0-.44,0-.88,0-1.32A36.46,36.46,0,0,1,76.3,0h.85c.49,0,1,0,1.45,0a36.45,36.45,0,0,1,35,34.95c0,.49,0,1,0,1.48V73.21c0,.4,0,.8,0,1.19a36.46,36.46,0,0,1-35.35,35.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeLogo);
export default __webpack_public_path__ + "static/media/resume_logo.f1a31f52938603464c4964cc9c651223.svg";
export { ForwardRef as ReactComponent };